const s = Symbol("form"), c = Symbol("form-item");
var o = /* @__PURE__ */ ((r) => (r.Ready = "ready", r.Validating = "validating", r.Success = "success", r.Error = "error", r))(o || {});
export {
  o as ValidateStateEnum,
  c as formItemKey,
  s as formKey
};
//# sourceMappingURL=form.js.map
